module.exports = __webpack_public_path__ + "img/A-White.12d59996.svg";